import { render, staticRenderFns } from "./ShareProfileModal.vue?vue&type=template&id=3a60cfdc"
import script from "./ShareProfileModal.vue?vue&type=script&lang=js"
export * from "./ShareProfileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports